import { HttpClient, HttpHeaders } from '@angular/common/http';

import { FormGroup } from "@angular/forms";
import { IService } from 'maps-angular-components';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleError } from '../shared/util/error-util';
import { getBackHost } from "../util/server-util";
import { Autocomplete } from './autocomplete';

export class AutocompleteService implements IService<Autocomplete>{

  constructor(private readonly http: HttpClient,  readonly url: string,
              readonly group:FormGroup, readonly filterFields: string[]) {
  }

  autocomplete(identificador: string, endpoint: string = '', filtros: any = {}): Observable<Autocomplete> {

    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params = [];

    params.push('identificador=' + encodeURIComponent(identificador));

    Object.keys(filtros).forEach(k => {
      if (filtros[k])
        params.push(k + '=' + encodeURIComponent(filtros[k]));
    });
    Object.keys(this.filterFields).forEach(k => {
      let value = this.group.get(this.filterFields[k]).value;
      value = value instanceof Object ? this.getValue(value): value
        params.push(`${this.filterFields[k]}=${encodeURIComponent(value)}`);
    });

    const options = {headers};
    return this.http.get<any>( getBackHost(`${this.url}?${params.join('&')}`), options).pipe(catchError(handleError));
  }

  private getValue(value) {
    let val = "";
    Object.keys(value).forEach(k => {
      if( Object.keys(value).length > 1 && typeof value[k] === "boolean" ){
        return;
      }
      val = value[k]  instanceof Array ? this.getArrayAsString(value[k]) : value[k].toString();
    });
    return val;
  }

  private getArrayAsString(valueElement: any[]) {
    return valueElement.map(v => v instanceof  Autocomplete ? v.getId() : v).join(",");
  }
}
